import * as React from "react"
import { useCheckbox, chakra, Flex, Text } from "@chakra-ui/react"
import { brandingSelector } from "../../../recoil/atoms/room"
import { useRecoilValue } from "recoil"
import { BsCheckLg } from "react-icons/bs"
import { Icon } from "../icons"

export const CustomCheckbox = React.memo((props: any) => {
  const { state, getCheckboxProps, getInputProps, getLabelProps, htmlProps } =
    useCheckbox(props)
  const roomStyles = useRecoilValue(brandingSelector)
  return (
    <chakra.label
      display="flex"
      flexDirection="row"
      alignItems="center"
      gridColumnGap={2}
      rounded="lg"
      cursor="pointer"
      opacity={props.isDisabled ? 0.4 : 1}
      {...htmlProps}
    >
      <input {...getInputProps()} hidden />
      <Flex
        alignItems="center"
        justifyContent="center"
        border="2px solid"
        order={props.changingplaces === "true" ? 2 : 1}
        borderColor={roomStyles?.servicePanelElementBorder ?? "gray"}
        borderRadius={props.ratiobutton === "true" ? "50%" : "0.125rem"}
        w={4}
        bg={roomStyles?.servicePanelElementBorderOffset}
        h={4}
        {...getCheckboxProps()}
      >
        {state.isChecked && (
          <Icon
            src={BsCheckLg}
            w={2}
            h={2}
            color={roomStyles?.servicePanelElementBorder ?? "gray"}
          />
        )}
      </Flex>
      <Text
        {...getLabelProps()}
        fontSize={props.fontSize ?? "sm"}
        order={props.changingplaces === "true" ? 1 : 2}
        color={
          roomStyles?.servicePanelElementPrimaryText &&
          roomStyles.servicePanelElementPrimaryText
        }
      >
        {props.label}
      </Text>
    </chakra.label>
  )
})
